import React from 'react';
import { ServiceLandingHero } from '../components/ServiceLandingHero';
import { ServiceDirectoryCard } from '../components/services/ServiceDirectoryCard';
import { directoryServices, featuredServices } from '../data/services';
import { servicesPage } from '../data/servicesPage';
export function ServicesPage() {
  const {
    hero,
    lead,
    care
  } = servicesPage;
  return <>
      <ServiceLandingHero id="top" eyebrow={hero.eyebrow} title={hero.title} intro={hero.intro} image={hero.image} alt={hero.alt} imagePosition={hero.imagePosition} tone="ivory" data-id="element-721" data-mp="2c8ck7bx9sn4y" />

      {/* Lead pair */}
      <section aria-labelledby="design-development-title" className="section-y border-t border-charcoal/10 bg-ivory" data-id="element-722" data-mp="2l2hgiav6aqrv">
        <div className="site-container" data-id="element-723" data-mp="2uyklrplbn5j1">
          <div className="grid gap-4 lg:grid-cols-12 lg:items-end lg:gap-14" data-id="element-724" data-mp="2uzvmfgjgzx5x">
            <h2 id="design-development-title" className="section-title text-charcoal lg:col-span-6" data-id="element-725" data-mp="2zwvsvsk8f1xk">{lead.title}</h2>
            <p className="max-w-[520px] text-[16px] leading-relaxed text-charcoal/75 lg:col-span-6" data-id="element-726" data-mp="2xl2mg9tzztx9">{lead.intro}</p>
          </div>
          <ul className="mt-10 grid gap-14 md:grid-cols-2 md:gap-10 lg:mt-12 lg:gap-14" data-id="element-727" data-mp="2sn111i93niim">
            {featuredServices.map(group => <li key={group.id} className="flex min-w-0" data-id="element-728" data-mp="2jkrraulnnt6a">
                <ServiceDirectoryCard group={group} variant="lead" data-id="element-729" data-mp="2jmcmmmfsng57" />
              </li>)}
          </ul>
        </div>
      </section>

      {/* Property-care pair */}
      <section aria-labelledby="property-care-title" className="section-y border-t border-olive/10 bg-[#E5E8DE]" data-id="element-730" data-mp="3bcqx08olmac4">
        <div className="site-container" data-id="element-731" data-mp="36iwfnbwgu7g7">
          <div className="grid gap-4 lg:grid-cols-12 lg:items-end lg:gap-14" data-id="element-732" data-mp="32jdwakkam4fh">
            <h2 id="property-care-title" className="section-title text-charcoal lg:col-span-6" data-id="element-733" data-mp="32hb2dpg0rr5h">{care.title}</h2>
            <p className="max-w-[520px] text-[16px] leading-relaxed text-charcoal/75 lg:col-span-6" data-id="element-734" data-mp="3uajxl4br286c">{care.intro}</p>
          </div>
          <ul className="mt-10 grid gap-7 md:grid-cols-2 lg:mt-12 lg:gap-8" data-id="element-735" data-mp="1sdswrczpwsgz">
            {directoryServices.map(group => <li key={group.id} className="flex min-w-0" data-id="element-736" data-mp="1xb2udfx9gafw">
                <ServiceDirectoryCard group={group} variant="care" data-id="element-737" data-mp="1inq79mrt1wne" />
              </li>)}
          </ul>
        </div>
      </section>
    </>;
}